var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoCms24X24 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ico_cms24x24",
    d: "M298.382,2.115a2.139,2.139,0,0,1,4.25-.347,3.535,3.535,0,0,1,3.317.946l.123.124-1.581,1.58-.123-.123a1.315,1.315,0,0,0-1.856,1.861l.308.309L304.4,8.046l1.67,1.671L304.492,11.3l-1.67-1.673-1.578-1.579-.3-.309a3.552,3.552,0,0,1-.888-3.531A2.143,2.143,0,0,1,298.382,2.115Zm4.627,4.163,1.579,1.58,1.671-1.669,1.579-1.58.309-.309a1.311,1.311,0,1,1,1.893,1.815L310,6.154l-.122.123,1.578,1.581.122-.124a3.553,3.553,0,0,0,.9-3.494,2.143,2.143,0,1,0-2.4-2.42,3.542,3.542,0,0,0-3.511.9l-.308.308-1.58,1.58Zm9.506,5.428a3.548,3.548,0,0,0-.936-3.351l-.312-.311-1.577-1.58-1.666-1.67-1.577,1.58,1.667,1.671,1.578,1.581.308.31a1.313,1.313,0,1,1-1.854,1.859h0l-.122-.121-1.577,1.58.121.12a3.543,3.543,0,0,0,3.554.883,2.14,2.14,0,1,0,2.4-2.55ZM309.5,9.812l-1.579-1.577L306.257,9.9l-1.578,1.58-.308.31a1.315,1.315,0,0,1-1.859-1.861l.123-.121-1.58-1.577-.118.117a3.552,3.552,0,0,0-.931,3.389,2.143,2.143,0,1,0,2.578,2.566,3.538,3.538,0,0,0,3.364-.933l.309-.311,1.578-1.582Z",
    transform: "translate(-298.357 .028)",
    fill: "#999"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoCms24X24);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_cms24x24.2e596b535918023ef793e0df96240572.svg";